import { Package } from '../../models/package';
import { createSelector } from '@ngrx/store';

export interface PackageEditorState {
    id: string | null;
    package: Package;
    loading: boolean;
    saving: boolean;
}

export const selectPackageEditorState = (state: any) => state.packageEditor;

export const selectPackageEditorId = createSelector(selectPackageEditorState,
    (state: PackageEditorState) => state.id);

export const selectPackageEditorPackage = createSelector(selectPackageEditorState,
    (state: PackageEditorState) => state.package);

export const selectPackageEditorLoading = createSelector(selectPackageEditorState,
    (state: PackageEditorState) => state.loading);

export const selectPackageEditorSaving = createSelector(selectPackageEditorState,
    (state: PackageEditorState) => state.saving);

